import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "transaction-confirm-card" }
const _hoisted_2 = { class: "modal-title" }
const _hoisted_3 = { class: "token-box-group" }
const _hoisted_4 = { class: "token-box" }
const _hoisted_5 = { class: "token-box-value" }
const _hoisted_6 = { class: "token-box-symbol token-name" }
const _hoisted_7 = { class: "token-box" }
const _hoisted_8 = { class: "token-box-value" }
const _hoisted_9 = { class: "token-box-symbol token-name" }
const _hoisted_10 = { class: "middle-arrow" }
const _hoisted_11 = { class: "arrow-icon" }
const _hoisted_12 = { class: "estimated-text" }
const _hoisted_13 = { class: "order-details-title" }
const _hoisted_14 = { class: "details-list" }
const _hoisted_15 = { class: "d-flex align-center" }
const _hoisted_16 = { class: "buttons-row" }
const _hoisted_17 = ["textContent"]
const _hoisted_18 = ["textContent"]
const _hoisted_19 = ["textContent"]

import { storeToRefs } from "pinia";
import { useTransactionConfirmModal } from "@/stores/transactionConfirmModal";
import TransactionConfirmDetailRow from "@/components/Dialogs/TransactionConfirmDetailRow.vue";
import FractionFormatter from "@/components/Common/Pricing/FractionFormatter.vue";
import {
  AETERNITY_SYMBOL,
  PROTOCOL_DAO_AFFILIATION_FEE,
  PROTOCOL_DAO_TOKEN_AE_RATIO,
} from "@/utils/constants";
import { formatFractionalPrice } from "@/utils/common";
import { computed } from "vue";
import { Decimal } from "@/libs/decimal";
import { useTokenTradeStore } from "@/stores/tokenTradeStore";
import LivePriceFormatter from "@/components/Common/Pricing/LivePriceFormatter.vue";
import ImpactBadge from "@/components/Common/ImpactBadge.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TradeTransactionConfirm',
  setup(__props) {

const {
  tokenA,
  tokenB,
  token,
  activeTradeView,
  isSelling,
  isBuying,
  isAllowSelling,
  priceImpactDiff,
  estimatedNextTokenPriceImpactDifferenceFormattedPercentage,
  desiredSlippage,
  averageTokenPrice,
  isUsingToken,
} = storeToRefs(useTokenTradeStore());

const { modalData } = storeToRefs(useTransactionConfirmModal());

const protocolTokenReward = computed(() => {
  const aeValue = isUsingToken.value ? tokenB.value : tokenA.value;
  return (
    Math.round(
      (1 - PROTOCOL_DAO_AFFILIATION_FEE) *
        PROTOCOL_DAO_TOKEN_AE_RATIO *
        (aeValue || 0) *
        100
    ) / 100
  );
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("dialogs.transactionConfirm.title", {
            action: _ctx.$t(`common.${_unref(activeTradeView)}`),
          })), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(FractionFormatter, {
                "fractional-price": 
                _unref(formatFractionalPrice)(_unref(Decimal).from(_unref(tokenA) ?? 0))
              
              }, null, 8, ["fractional-price"])
            ]),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(isBuying) ? _unref(AETERNITY_SYMBOL) : _unref(token)?.symbol), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(FractionFormatter, {
                "fractional-price": 
                _unref(formatFractionalPrice)(_unref(Decimal).from(_unref(tokenB) ?? 0))
              
              }, null, 8, ["fractional-price"])
            ]),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(isBuying) ? _unref(token)?.symbol : _unref(AETERNITY_SYMBOL)), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_v_icon, { size: "x-small" }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode("mdi-arrow-down")
                ])),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("dialogs.transactionConfirm.estimatedOutput", {
            amount: _unref(formatFractionalPrice)(_unref(Decimal).from(_unref(tokenB) ?? 0)).number,
            symbol: _unref(isBuying) ? _unref(token)?.symbol : _unref(AETERNITY_SYMBOL),
          })), 1),
        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("common.orderDetails")), 1),
        _createElementVNode("div", _hoisted_14, [
          (!_unref(averageTokenPrice).isZero && !_unref(averageTokenPrice).infinite)
            ? (_openBlock(), _createBlock(TransactionConfirmDetailRow, {
                key: 0,
                label: _ctx.$t('common.avgTokenPrice')
              }, {
                default: _withCtx(() => [
                  _createVNode(LivePriceFormatter, {
                    row: "",
                    "ae-price": _unref(averageTokenPrice),
                    "watch-price": false
                  }, null, 8, ["ae-price"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          _createVNode(TransactionConfirmDetailRow, {
            label: _ctx.$t('common.allowedSlippage')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(Number(_unref(desiredSlippage) ?? 0).toFixed(2)) + "% ", 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(TransactionConfirmDetailRow, {
            label: _ctx.$t('common.priceImpact')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass([
              _unref(isBuying) ? 'text-green' : 'text-red',
              'd-flex align-center ga-1',
            ])
              }, [
                _createElementVNode("div", _hoisted_15, [
                  _createTextVNode(_toDisplayString(_unref(isBuying) ? "+" : "-"), 1),
                  _createVNode(FractionFormatter, {
                    "fractional-price": _unref(formatFractionalPrice)(_unref(priceImpactDiff))
                  }, null, 8, ["fractional-price"]),
                  _createTextVNode(" " + _toDisplayString(_unref(AETERNITY_SYMBOL)), 1)
                ]),
                _createVNode(ImpactBadge, {
                  "is-positive": _unref(isBuying),
                  "is-zero": _unref(priceImpactDiff).isZero,
                  percentage: 
                _unref(estimatedNextTokenPriceImpactDifferenceFormattedPercentage)
              
                }, null, 8, ["is-positive", "is-zero", "percentage"])
              ], 2)
            ]),
            _: 1
          }, 8, ["label"]),
          (_unref(isBuying))
            ? (_openBlock(), _createBlock(TransactionConfirmDetailRow, {
                key: 1,
                label: _ctx.$t('common.protocolTokenReward')
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(protocolTokenReward.value), 1)
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_16, [
          (_unref(isSelling))
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                block: "",
                color: "primary",
                size: "large",
                disabled: !_unref(isAllowSelling),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(modalData).confirm && _unref(modalData).confirm()))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    textContent: _toDisplayString(
              _unref(isAllowSelling)
                ? _ctx.$t('common.allowUseOfToken')
                : _ctx.$t('common.useOfTokenAllowed')
            )
                  }, null, 8, _hoisted_17)
                ]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true),
          _createVNode(_component_v_btn, {
            block: "",
            color: "primary",
            size: "large",
            disabled: _unref(isSelling) && _unref(isAllowSelling),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(modalData).confirm && _unref(modalData).confirm()))
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                textContent: _toDisplayString(_ctx.$t('common.confirm'))
              }, null, 8, _hoisted_18)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_v_btn, {
            block: "",
            variant: "text",
            size: "small",
            color: "rgba(255, 255, 255, 0.5)",
            class: "text-uppercase",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(modalData).reject && _unref(modalData).reject()))
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                textContent: _toDisplayString(_ctx.$t('common.cancel'))
              }, null, 8, _hoisted_19)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})